import { observer } from 'mobx-react-lite'

import { useDebtStore, useGlobalCopyStore, useGoalStore } from '../../../common'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface PaydownButtonProps {
  disabled?: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const PaydownButton = observer(({ disabled, onClick }: PaydownButtonProps) => {
  const { debts: copy } = useGlobalCopyStore()
  const { totalMonthlyPayments } = useDebtStore()
  const { monthlyCashFlowProfile } = useGoalStore()

  const totalContributions = totalMonthlyPayments + Number(monthlyCashFlowProfile?.extra_payment)
  const buttonText = copy.paydown_button_long
  return (
    <Stack alignItems="center" sx={{ flex: 1, flexShrink: 0 }}>
      <Button
        aria-controls="extra-paydown"
        aria-describedby="extra-paydown"
        aria-haspopup={true}
        aria-label="extra-paydown"
        disabled={disabled}
        onClick={onClick}
        sx={{ justifyContent: 'start' }}
      >
        {buildDynamicCopy(buttonText, formatCurrency(totalContributions, '0,0')) as string}
      </Button>
    </Stack>
  )
})
